import dynamic from 'next/dynamic'
import { DriveTimeIcon } from 'src/components/insights/icons/drive-time'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import driveTimeTradeAreaMapPreview from 'src/assets/images/widgets-previews/drive-time-trade-area-map.png'
import driveTimeTradeAreaOverviewPreview from 'src/assets/images/widgets-previews/drive-time-trade-area-overview.png'
import driveTimeTradeAreaConsumerSpendPreview from 'src/assets/images/widgets-previews/drive-time-trade-area-consumer-spend.png'
import driveTimeTradeAreaDemographicsPreview from 'src/assets/images/widgets-previews/drive-time-trade-area-demographics.png'

const DriveTimeTradeAreaMap = dynamic(() => import('src/components/insights/drive-time-trade-area/map'), {
  ssr: false,
})

const DriveTimeTradeAreaOverview = dynamic(() => import('src/components/insights/drive-time-trade-area/overview'), {
  ssr: false,
})

const DriveTimeTradeAreaConsumerSpend = dynamic(
  () => import('src/components/insights/drive-time-trade-area/consumer'),
  {
    ssr: false,
  }
)

const DriveTimeTradeAreaDemographics = dynamic(
  () => import('src/components/insights/drive-time-trade-area/demographics'),
  {
    ssr: false,
  }
)

export const DriveTimeTradeAreaMapWidget: InsightBuilderWidget = {
  id: 'drive-time-trade-area-map',
  name: 'Drive Time Map',
  type: 'Drive Time Trade Area',
  icon: DriveTimeIcon,
  component: DriveTimeTradeAreaMap,
  supportedResultTypes: ['alphamap-location'],
  preview: driveTimeTradeAreaMapPreview,
}

export const DriveTimeTradeAreaOverviewWidget: InsightBuilderWidget = {
  id: 'drive-time-trade-area-overview',
  name: 'Drive Time Overview',
  type: 'Drive Time Trade Area',
  icon: DriveTimeIcon,
  component: DriveTimeTradeAreaOverview,
  supportedResultTypes: ['alphamap-location'],
  preview: driveTimeTradeAreaOverviewPreview,
}

export const DriveTimeTradeAreaConsumerSpendWidget: InsightBuilderWidget = {
  id: 'drive-time-trade-area-consumer-spend',
  name: 'Drive Time Consumer Spend',
  type: 'Drive Time Trade Area',
  icon: DriveTimeIcon,
  component: DriveTimeTradeAreaConsumerSpend,
  supportedResultTypes: ['alphamap-location'],
  preview: driveTimeTradeAreaConsumerSpendPreview,
}

export const DriveTimeTradeAreaDemographicsWidget: InsightBuilderWidget = {
  id: 'drive-time-trade-area-demographics',
  name: 'Drive Time Demographics',
  type: 'Drive Time Trade Area',
  icon: DriveTimeIcon,
  component: DriveTimeTradeAreaDemographics,
  supportedResultTypes: ['alphamap-location'],
  preview: driveTimeTradeAreaDemographicsPreview,
}
